// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateGroupComponent } from '@coa/app/shared/add-to-group-dialog/modules/create-group/components/create-group.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { createGroupReducer, STATE_NAME } from '@coa/app/shared/add-to-group-dialog/modules/create-group/store/create-group.reducer';
import { CreateGroupEffects } from '@coa/app/shared/add-to-group-dialog/modules/create-group/store/create-group.effects';
import { CreateGroupHeaderComponent } from './components/create-group-header/create-group-header.component';
import { CreateGroupBodyComponent } from './components/create-group-body/create-group-body.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { CuiButtonModule } from '@coa/app/shared/button/button.module';

@NgModule({
  declarations: [
    CreateGroupComponent,
    CreateGroupHeaderComponent,
    CreateGroupBodyComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, createGroupReducer),
    EffectsModule.forFeature([CreateGroupEffects]),
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CuiButtonModule,
  ],
  exports: [
    CreateGroupComponent,
  ],
})
export class CreateGroupModule {
}
